import BaseServiceCrud from './BaseServiceCrud';

export default class QRCodeService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'qrcode';
    }

    getCriteria(criteria) {
        return this.objToQueryString({
            locale: criteria.locale,
            title: criteria?.title,
            coinsFrom: criteria?.coinsFrom,
            coinsTo: criteria?.coinsTo,
            first_result: criteria.firstResult,
            max_results: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
        });
    }

    
    removeQRCode(id) {
        return this.fetch(`${this.domain}/${this.path}/${id}`, {
            method: 'DELETE',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    publish(id) {
        return this.fetch(`${this.domain}/${this.path}/publish/${id}`, {
            method: 'PUT',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

}
